
<template>
  <div id="program-course-progress-widget">
    <div v-if="isClientVerified">
      <template v-if="isAuthenticated">
        <template v-if="isLoadAddedCourseList">
          <program-course-progress ref="reportedCourseList" :pathway-id="pathwayId"></program-course-progress>
        </template>
<!--
        <template v-if="isLoadAddedCourseList">
          <program-education ref="reportedCourseList" :pathway-id="pathwayId"></program-education>
        </template>
       <template v-if="isLoadAddedCourseList">
          <program-cocurricular ref="reportedCourseList" :pathway-id="pathwayId"></program-cocurricular>
        </template>
-->
      </template>
     <template v-else>
        <div class="text-center" style="margin-top: 40px;">
          <h3>You are not authorized. Please contact your administrator.</h3>
        </div>
      </template>
    </div>
  </div>
</template>


<script>
  import { mapActions } from 'vuex'
  import '../assets/theme/default/sass/global.scss'
  //import '../assets/theme/default/css/defaultTheme.min.css'
  import '../assets/module/css/explore/explore.min.css'
  import ProgramCourseProgress from './transfer/components/ProgramCourseProgress'
  import ProgramEducation from './transfer/components/ProgramEducation'
  import ProgramCocurricular from './transfer/components/ProgramCocurricular'
  import { StorageFactory } from '../storageFactory'

  export const localStore = StorageFactory(() => localStorage)

  export default {
    name: 'program-course-progress-widget-app',
    components: {
      ProgramCourseProgress,
      ProgramEducation,
      ProgramCocurricular
    },
    data: () => {
      return {
        key: null,
        secret: null,
        userId: null,
        pathwayId: null,
        firstName: null,
        lastName: null,
        institutionId: null,
        isAuthenticated: false,
        isClientVerified: false,
        isLoadAddedCourseList: false,
        isGuestLogin: (localStore.getItem('userrole') === 'Guest')
      }
    },
    mounted () {
      if (this.$route.query) {
        this.key = this.$route.query.key
        this.secret = this.$route.query.secret
        this.userId = this.$route.query.userId
        this.pathwayId = this.$route.query.pathwayId
        this.authenticateWidget()
        window.addEventListener('message', (event) => {
          if (event.data.name === 'PostLogin') {
            let data = event.data.data
            this.userId = data.userId
            this.pathwayId = data.pathwayId
            setTimeout(() => {
              this.loadLoginUser()
            }, 500)
          }
        })
      }
    },
    methods: {
      ...mapActions([
        'loadAuthenticateWidget',
        'loadLoginCourseReportingWidgetUser'
      ]),
      async authenticateWidget () {
        this.institutionId = await this.loadAuthenticateWidget({key: this.key, secret: this.secret, type: 'COURSE_REPORTING'})
        if (this.institutionId) {
          this.isClientVerified = true
          this.isAuthenticated = true
          this.loadLoginUser()
        } else {
          this.isAuthenticated = false
        }
      },
      async loadLoginUser () {
        let data = {
          userId: this.userId,
          firstName: this.firstName,
          lastName: this.lastName
        }
        let userObj = await this.loadLoginCourseReportingWidgetUser({institutionId: this.institutionId, data: data})
        if (userObj && userObj.roles[0].role !== 'Guest') {
          this.isLoadAddedCourseList = true
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/ProgramCourseProgressWidgetApp.vue